import React, { useEffect } from "react";
import "./P_Card.css";
import { AiFillEye } from "react-icons/ai";
import { BsGithub } from "react-icons/bs";
import { Tooltip } from "@material-ui/core";

import AOS from "aos";
import "aos/dist/aos.css";

const PCard = ({ name, img, description, link, preview }) => {
  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);

  return (
    <div className="P_card" data-aos="slide-up">
      <div className="P_card-img">
        <img src={img} alt={name} />
      </div>
      <div className="p_card-content">
        <h3> {name}</h3>
        <p>{description}</p>
        {preview && (
          <Tooltip
            title="See a live preview of this page hosted on netlify"
            placement="left-start"
          >
            <a href={preview} className="Pcardview" target="_blank">
              <AiFillEye size={30} /> Preview
            </a>
          </Tooltip>
        )}
        <Tooltip title="View ths source code on my github page">
          <a href={link} className="Pcardview" target="_blank">
            <BsGithub size={20} /> Source code
          </a>
        </Tooltip>
      </div>
    </div>
  );
};

export default PCard;
